module.exports = __webpack_public_path__ + "static/media/background-vid.2b967fdf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/background-vid.mp4
// module id = 152
// module chunks = 0